import { HttpErrorResponse } from '@angular/common/http';
import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnDestroy,
  Output
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  AppInsightService,
  BrowserEventService,
  Game,
  LobbyType,
  LogEvents,
  StorageService,
  StorageType
} from '@rct/lynx-lobbies-shared-lib';
import { Subject } from 'rxjs';
import { concatMap, takeUntil } from 'rxjs/operators';
import { LYNX_STORAGE_KEYS } from '../../../constants/lynx-storage-keys.constant';
import { ModalIconType } from '../../../enums/modal-icon-type';
import { LynxGameService } from '../../../services/game.service';
import { LynxLobbyService } from '../../../services/lobby.service';
import { LynxModalService } from '../../../services/modal.service';

@Component({
    selector: 'lynx-game-card',
    templateUrl: './game-card.component.html',
    styleUrls: ['./game-card.component.scss'],
    standalone: false
})
export class GameCardComponent implements OnDestroy {
  @Input() game: Game;
  @Input() categoryId: string;
  @Output() openGame = new EventEmitter();

  private translateService = inject(TranslateService);

  lobbyId = '';

  destroy$ = new Subject<boolean>();

  get isMobile(): boolean {
    return this.browserEventService.isMobile();
  }

  constructor(
    private gameService: LynxGameService,
    private lobbyService: LynxLobbyService,
    private browserEventService: BrowserEventService,
    private storageService: StorageService,
    private appInsightService: AppInsightService,
    private modalService: LynxModalService
  ) {
    this.lobbyId = this.storageService.get(
      LYNX_STORAGE_KEYS.lobbyId,
      StorageType.Session
    );
  }

  launchGame(game: Game): void {
    this.gameService
      .openGame(game.launchGameCode, this.isMobile, this.categoryId)
      .pipe(
        concatMap(() => this.lobbyService.lobbyTemplateId$),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (lobbyTemplateId: string) => {
          this.appInsightService.logEvent(
            { storageKeys: LYNX_STORAGE_KEYS, lobbyType: LobbyType.Lynx },
            LogEvents.onGameClick,
            {
              game: game.gameName,
              lobbyId: this.lobbyId,
              lobbyTemplateId,
              gameCode: game.launchGameCode,
            }
          );
          this.appInsightService.gaEvent(
            { storageKeys: LYNX_STORAGE_KEYS, lobbyType: LobbyType.Lynx },
            LogEvents.onGameClick,
            `game: ${game.gameName}, lobbyId: ${this.lobbyId.split('-').slice(0, 2).join('-')}, lobbyTemplateId: ${lobbyTemplateId.split('-').slice(0, 2).join('-')}`
          );
        },
        (err: HttpErrorResponse) => {
          this.modalService.dispatch({
            icon: ModalIconType.WARNING,
            title: 'Modal.ErrorModal.GeneralError.Title',
            content: [
              'Modal.ErrorModal.GeneralError.Content.0',
              'Modal.ErrorModal.GeneralError.Content.1'
            ],
            data: {
              LobbyID: this.lobbyId,
              GameName: game.gameName
            }
          });
        }
      );
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
